// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 660 ? "38205b58" : chunkId) + "." + {"660":"803bd713cd4eaec0","4118":"1c3160f4a167d2df"}[chunkId] + ".js";
};